import React, { useState } from 'react'
import Menu from '@mui/material/Menu'
import { trans } from '../../../../_providers/Translation'

import menuIcon from '../../../../assets/img/icons/table-menu.png'
import editIcon from '../../../../assets/img/icons/edit.svg'
import deleteIcon from '../../../../assets/img/icons/delete.svg'

function CommentMenu(props) {
    const [anchorEl, setAnchorEl] = useState(null)

    const handleOpen = e => {
        e.stopPropagation()
        setAnchorEl(e.currentTarget)
    }

    const handleClose = e => {
        if (e) e.stopPropagation()
        setAnchorEl(null)
    }

    const handleEdit = e => {
        handleClose(e)
        if (props.onEdit) props.onEdit()
    }

    const handleDelete = e => {
        handleClose(e)
        if (props.onDelete) props.onDelete()
    }

    return (
        <>
            <img
                src={menuIcon}
                alt="menu"
                className="menu"
                onClick={handleOpen}
                style={{ padding: '10px', margin: '-10px', cursor: 'pointer', display: 'block' }}
            />
            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <div className="menu-option" onClick={handleEdit}>
                    <img src={editIcon} alt="edit" />
                    {trans('buttons.edit')}
                </div>
                <div className="menu-option" onClick={handleDelete} style={{ color: '#EC5252' }}>
                    <img src={deleteIcon} alt="delete" />
                    {trans('buttons.delete')}
                </div>
            </Menu>
        </>
    )
}

export default CommentMenu
